export const BACKEND_URL = "https://portal-bff-576106341341.us-central1.run.app";
// export const BACKEND_URL = "http://localhost:3000";
// exports.BACKEND_URL = "http://localhost:3001"

// Public (non-secret) half of the web-push VAPID key pair (feature #11, L3).
// The private half lives in Secret Manager (read only by the BFF). Kept here
// as a build-time constant rather than REACT_APP_VAPID_PUBLIC_KEY so push works
// without touching the CI env-var pipeline.
export const VAPID_PUBLIC_KEY =
  "BJkHVrsWzghsUek9e0sGPtVjRTF3jWnHzPXK3dYs6nW7AY6fBJHCyHBudqYKXI6q1lkSil3GRHX8w2jb3xicCGo";
